import type { AxiosError, AxiosRequestConfig } from 'axios';
import { apiClient } from './client';

// AxiosRequestConfigにカスタムプロパティを追加
declare module 'axios' {
  interface AxiosRequestConfig {
    /** trueの場合、レスポンスインターセプターでのエラーtoast表示を抑制する */
    suppressToast?: boolean;
  }
}

/**
 * orval用カスタムインスタンス
 *
 * 既存のapiClientをラップし、orvalが要求するシグネチャに適合させます。
 * この実装により、既存のトークン管理、エラーハンドリング、
 * インターセプターロジックをそのまま活用できます。
 */
export const customInstance = async <T = unknown>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<T> => {
  // 既存のapiClientを使用（トークン管理・エラーハンドリング含む）
  const mergedConfig: AxiosRequestConfig = {
    ...config,
    ...options,
  };
  const response = await apiClient.request<T>(mergedConfig);
  return response.data;
};

/**
 * orvalが要求する型定義
 * これらの型エクスポートは必須です
 */

// エラー型（AxiosErrorをそのまま使用）
export type ErrorType<Error = unknown> = AxiosError<Error>;

// ボディ型（リクエストボディの型）
export type BodyType<BodyData> = BodyData;
